import { Login } from "@/modules/auth/components";

export const LoginPage = () => {
  return <Login />;
};
